﻿import { BaseWidget } from "../BaseWidget"

export class RadioList extends BaseWidget {
    private lastValue: string = "none";
    allRadios: NodeListOf<HTMLInputElement>;

    afterIndex() {
        this.muRegisterEvent("change");
        this.allRadios = this.container.querySelectorAll('input[type="radio"]') as NodeListOf<HTMLInputElement>;

        for (const r of this.allRadios) {
            r.addEventListener("change", (ev) => {
                const val = this.muFetchData();
                if (val !== this.lastValue) {
                    this.muDispatchEvent("change", this.muFetchData());
                    this.lastValue = val ?? "";
                }
            });

            r.addEventListener("mouseup", (ev) => {
                ev.preventDefault();
                ev.stopPropagation();

                const isChecked = r.value === this.muFetchData();
                r.checked = !isChecked;

                if (!isChecked) {
                    this.lastValue = "none";
                }

                r.dispatchEvent(new Event("change", { bubbles: true }));
            });

            r.addEventListener("mousedown", (ev) => { ev.preventDefault(); ev.stopPropagation(); });
            r.addEventListener("focus", (ev) => { ev.preventDefault(); ev.stopPropagation(); });

            const associatedLabel = this.container.querySelector(`label[for="${r.id}"]`);
            if (associatedLabel) {
                associatedLabel.addEventListener("click", (ev) => {
                    ev.preventDefault();
                    ev.stopPropagation();
                    r.dispatchEvent(new MouseEvent("mouseup", { bubbles: true })); // Manually trigger click event on the associated radio button
                });
            }
        }
    }

    override muFetchData(): string | null {
        for (const r of this.allRadios) {
            if (r.checked) {
                return r.value;
            }
        }
        return null;
    }

    override muBindData(value: string | null): void {
        for (const r of this.allRadios) {
            r.checked = r.value === value;
        }
    }
}

export class RadioListOther extends BaseWidget {
    private lastValue: string = "none";

    updateForm() {
        this.value_change();
    }

    value_change() {
        const v = this.muNamedWidget.value.muFetchData();
        this.hideElement(this.findTagElementParent(this.ui.other, "div"), v === "other" || v === "");
    }
}
